import { useRouter } from 'next/router'

import { isUUID } from '@/types/Id'

export const useActivePursuitId = () => {
  const router = useRouter()
  const activePursuitId = router.query.pursuitId || ''
  return {
    activePursuitId: isUUID(activePursuitId) ? activePursuitId : ('' as const),
  }
}
